import React, { memo } from "react";
import { Field } from "formik";
import { TextField } from "formik-material-ui";
import { Grid } from "@material-ui/core";

import { PARCEL_NUMBER } from "../../../constants/strings";
import ParcelSearchButtons from "./ParcelSearchButtons";
import ParcelSearchResult from "./ParcelSearchResult";

const ParcelSearchForm = ({
  values,
  handleFinish,
  parcelNumberRef,
  handleReset,
  handleSearch,
  foundParcels,
  errors,
}) => (
  <>
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Field
          component={TextField}
          name="parcelNumber"
          type="text"
          label={PARCEL_NUMBER}
          variant="outlined"
          data-testid="parcel-number"
          value={values?.parcelNumber}
          inputRef={parcelNumberRef}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <ParcelSearchResult results={foundParcels} errors={errors} />
      </Grid>
      <Grid item xs={12}>
        <ParcelSearchButtons
          handleSearch={handleSearch}
          handleReset={handleReset}
          handleFinish={handleFinish}
          parcelNumber={values.parcelNumber}
        />
      </Grid>
    </Grid>
  </>
);

export default memo(ParcelSearchForm);
